<template>
  <div class="fill-height">
    <v-layout fill-height wrap class="pt-4">
      <v-col cols="12" lg="3" md="3">
        <div class="recentbox fill-height mr-2 ml-2" style="height: 100%!important;">
          <div class="mr-4 ml-4 mt-2 rounded">
            <v-text-field filled dense placeholder="Cari..." rounded></v-text-field>
          </div>
          <v-divider/>
          <v-list two-line>
            <v-list-item-group
                v-model="selecteditemx"
                active-class="green--text">
              <template v-for="(item,i) in chatlist">
                <v-list-item @click="openchat(item)"  :key="'key'+item.groupid">
                  <v-list-item-avatar v-if="item.userb.member.memberavatar">
                    <v-img :src="item.userb.member.memberavatar"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-avatar v-else>
                    <v-img contain src="../assets/irsicon.jpg"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content class="">
                    <v-list-item-title>{{item.userb.member.membername}}</v-list-item-title>
                    <v-list-item-subtitle>{{item.msg}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text v-text="formatwaktu(item.updateat)"></v-list-item-action-text>
                    <div v-if="item.dibaca===0" class="primary" style="width: 8px;height: 8px;border-radius: 4px">
                    </div>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="i<chatlist.length-1" :key="i"></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
        </div>
      </v-col>
      <v-col cols="12" lg="9" md="9">
        <div class="recentbox fill-height mr-2" style="height: 100%!important;">
          <div>
            <Chatwelcome v-if="selectedchat===null"/>
            <ChatCompose v-else/>
          </div>
        </div>
      </v-col>
    </v-layout>
  </div>
</template>

<script>
import Chatwelcome from '@/components/chat/chatwelcome'
import ChatCompose from '@/components/chat/ChatCompose'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'ChatPage',
  components: { ChatCompose, Chatwelcome },
  data: () => ({
    selecteditemx: null
  }),
  mounted () {
    this.getChatList()
  },
  computed: {
    ...mapState('ChatStore', ['messages', 'chatlist', 'selectedchat'])
  },
  methods: {
    ...mapActions('ChatStore', ['getChatList', 'getMessages', 'setselectedgroupid', 'setselectedchat', 'doReadGroupMSg']),
    formatwaktu (value) {
      return moment(value).add(0, 'hours').format('HH:mm:ss')
    },
    openchat (chat) {
      this.setselectedchat(chat)
      this.setselectedgroupid(chat.groupid)
      this.getMessages(chat.groupid)
      this.doReadGroupMSg(chat.groupid)
    }
  }
}
</script>

<style scoped>
.recentbox {
  border: thin solid rgba(0,0,0,.12)
}
.fill-height {
  height: 94% !important;
}
</style>
